import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


const store = new Vuex.Store({
  state: {
    userInfo: null,
    token: null,
  },
  getter: {
    getStateInfo: function (state) {
      return state.userInfo
    },
    getToken: function (state) {
      return state.token
    },

  },
  mutations: {
    getUserInfo(state, date) {
      state.userInfo = date
    },
    getToken(state, data) {
      state.token = data
    },

  },
  actions: {
    getUserInfo(context, date) {
      context.commit('getUserInfo', date)
    },
    getToken(context, date) {
      context.commit('getToken', date)
    },

  },
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js